"use strict"; // doT.js
// 2011-2014, Laura Doktorova, https://github.com/olado/doT
// Licensed under the MIT license.

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var doT = {
  templateSettings: {
    argName: "it",
    encoders: {},
    selfContained: false,
    strip: true,
    internalPrefix: "_val",
    encodersPrefix: "_enc",
    delimiters: {
      start: "{{",
      end: "}}"
    }
  },
  template: template,
  compile: compile,
  setDelimiters: setDelimiters
};
module.exports = doT; // depends on selfContained mode

var encoderType = {
  false: "function",
  true: "string"
};
var defaultSyntax = {
  evaluate: /\{\{([\s\S]+?(\}?)+)\}\}/g,
  interpolate: /\{\{=([\s\S]+?)\}\}/g,
  typeInterpolate: /\{\{%([nsb])=([\s\S]+?)\}\}/g,
  encode: /\{\{([a-z_$]+[\w$]*)?!([\s\S]+?)\}\}/g,
  use: /\{\{#([\s\S]+?)\}\}/g,
  useParams: /(^|[^\w$])def(?:\.|\[[\'\"])([\w$\.]+)(?:[\'\"]\])?\s*\:\s*([\w$]+(?:\.[\w$]+|\[[^\]]+\])*|\"[^\"]+\"|\'[^\']+\'|\{[^\}]+\})/g,
  define: /\{\{##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\}\}/g,
  defineParams: /^\s*([\w$]+):([\s\S]+)/,
  conditional: /\{\{\?(\?)?\s*([\s\S]*?)\s*\}\}/g,
  iterate: /\{\{~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\}\})/g
};

var currentSyntax = _objectSpread({}, defaultSyntax);

var TYPES = {
  n: "number",
  s: "string",
  b: "boolean"
};

function resolveDefs(c, syn, block, def) {
  return (typeof block === "string" ? block : block.toString()).replace(syn.define, function (_, code, assign, value) {
    if (code.indexOf("def.") === 0) {
      code = code.substring(4);
    }

    if (!(code in def)) {
      if (assign === ":") {
        value.replace(syn.defineParams, function (_, param, v) {
          def[code] = {
            arg: param,
            text: v
          };
        });
        if (!(code in def)) def[code] = value;
      } else {
        new Function("def", "def['".concat(code, "']=").concat(value))(def);
      }
    }

    return "";
  }).replace(syn.use, function (_, code) {
    code = code.replace(syn.useParams, function (_, s, d, param) {
      if (def[d] && def[d].arg && param) {
        var rw = unescape((d + ":" + param).replace(/'|\\/g, "_"));
        def.__exp = def.__exp || {};
        def.__exp[rw] = def[d].text.replace(new RegExp("(^|[^\\w$])".concat(def[d].arg, "([^\\w$])"), "g"), "$1".concat(param, "$2"));
        return s + "def.__exp['".concat(rw, "']");
      }
    });
    var v = new Function("def", "return " + code)(def);
    return v ? resolveDefs(c, syn, v, def) : v;
  });
}

function unescape(code) {
  return code.replace(/\\('|\\)/g, "$1").replace(/[\r\t\n]/g, " ");
}

function template(tmpl, c, def) {
  var ds = c && c.delimiters;
  var syn = ds && !sameDelimiters(ds) ? getSyntax(ds) : currentSyntax;
  c = c ? _objectSpread(_objectSpread({}, doT.templateSettings), c) : doT.templateSettings;
  var sid = 0;
  var str = resolveDefs(c, syn, tmpl, def || {});
  var needEncoders = {};
  str = ("let out='" + (c.strip ? str.trim().replace(/[\t ]+(\r|\n)/g, "\n") // remove trailing spaces
  .replace(/(\r|\n)[\t ]+/g, " ") // leading spaces reduced to " "
  .replace(/\r|\n|\t|\/\*[\s\S]*?\*\//g, "") // remove breaks, tabs and JS comments
  : str).replace(/'|\\/g, "\\$&").replace(syn.interpolate, function (_, code) {
    return "'+(".concat(unescape(code), ")+'");
  }).replace(syn.typeInterpolate, function (_, typ, code) {
    sid++;
    var val = c.internalPrefix + sid;
    var error = "throw new Error(\"expected ".concat(TYPES[typ], ", got \"+ (typeof ").concat(val, "))");
    return "';const ".concat(val, "=(").concat(unescape(code), ");if(typeof ").concat(val, "!==\"").concat(TYPES[typ], "\") ").concat(error, ";out+=").concat(val, "+'");
  }).replace(syn.encode, function (_) {
    var enc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var code = arguments.length > 2 ? arguments[2] : undefined;
    needEncoders[enc] = true;
    code = unescape(code);
    var e = c.selfContained ? enc : enc ? "." + enc : '[""]';
    return "'+".concat(c.encodersPrefix).concat(e, "(").concat(code, ")+'");
  }).replace(syn.conditional, function (_, elseCase, code) {
    if (code) {
      code = unescape(code);
      return elseCase ? "';}else if(".concat(code, "){out+='") : "';if(".concat(code, "){out+='");
    }

    return elseCase ? "';}else{out+='" : "';}out+='";
  }).replace(syn.iterate, function (_, arr, vName, iName) {
    if (!arr) return "';} } out+='";
    sid++;
    var defI = iName ? "let ".concat(iName, "=-1;") : "";
    var incI = iName ? "".concat(iName, "++;") : "";
    var val = c.internalPrefix + sid;
    return "';const ".concat(val, "=").concat(unescape(arr), ";if(").concat(val, "){").concat(defI, "for (const ").concat(vName, " of ").concat(val, "){").concat(incI, "out+='");
  }).replace(syn.evaluate, function (_, code) {
    return "';".concat(unescape(code), "out+='");
  }) + "';return out;").replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r").replace(/(\s|;|\}|^|\{)out\+='';/g, "$1").replace(/\+''/g, "");
  var args = Array.isArray(c.argName) ? properties(c.argName) : c.argName;

  if (Object.keys(needEncoders).length === 0) {
    return try_(function () {
      return new Function(args, str);
    });
  }

  checkEncoders(c, needEncoders);
  str = "return function(".concat(args, "){").concat(str, "};");
  return try_(function () {
    return c.selfContained ? new Function(str = addEncoders(c, needEncoders) + str)() : new Function(c.encodersPrefix, str)(c.encoders);
  });

  function try_(f) {
    try {
      return f();
    } catch (e) {
      console.log("Could not create a template function: " + str);
      throw e;
    }
  }
}

function compile(tmpl, def) {
  return template(tmpl, null, def);
}

function sameDelimiters(_ref) {
  var start = _ref.start,
      end = _ref.end;
  var d = doT.templateSettings.delimiters;
  return d.start === start && d.end === end;
}

function setDelimiters(delimiters) {
  if (sameDelimiters(delimiters)) {
    console.log("delimiters did not change");
    return;
  }

  currentSyntax = getSyntax(delimiters);
  doT.templateSettings.delimiters = delimiters;
}

function getSyntax(_ref2) {
  var start = _ref2.start,
      end = _ref2.end;
  start = escape(start);
  end = escape(end);
  var syntax = {};

  for (var syn in defaultSyntax) {
    var s = defaultSyntax[syn].toString().replace(/\\\{\\\{/g, start).replace(/\\\}\\\}/g, end);
    syntax[syn] = strToRegExp(s);
  }

  return syntax;
}

var escapeCharacters = /([{}[\]()<>\\\/^$\-.+*?!=|&:])/g;

function escape(str) {
  return str.replace(escapeCharacters, "\\$1");
}

var regexpPattern = /^\/(.*)\/([\w]*)$/;

function strToRegExp(str) {
  var _str$match = str.match(regexpPattern),
      _str$match2 = _slicedToArray(_str$match, 3),
      rx = _str$match2[1],
      flags = _str$match2[2];

  return new RegExp(rx, flags);
}

function properties(args) {
  return args.reduce(function (s, a, i) {
    return s + (i ? "," : "") + a;
  }, "{") + "}";
}

function checkEncoders(c, encoders) {
  var typ = encoderType[c.selfContained];

  for (var enc in encoders) {
    var e = c.encoders[enc];
    if (!e) throw new Error("unknown encoder \"".concat(enc, "\""));
    if (_typeof(e) !== typ) throw new Error("selfContained ".concat(c.selfContained, ": encoder type must be \"").concat(typ, "\""));
  }
}

function addEncoders(c, encoders) {
  var s = "";

  for (var enc in encoders) {
    s += "const ".concat(c.encodersPrefix).concat(enc, "=").concat(c.encoders[enc], ";");
  }

  return s;
}